module.exports = __webpack_public_path__ + "img/volkswagen-header.38958462.png";